export class LayoutControlOptions {
    constructor() {
        /**
         * 控件名称
         */
        this.name = '';
        /**
         * 对齐
         */
        this.align = 'left';
        /**
         * 控件样式
         */
        this.style = null;
        /**
         * 显示条件
         */
        this.displayFormula = '';
        /**
         * tip提示
         */
        this.tips = '';
    }
}
/**
 * 分组标题
 */
export class GroupTitleOptions extends LayoutControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 默认展开
         */
        this.expand = true;
    }
}
export class TabsOptions {
    constructor() {
        this.heads = [];
    }
}
